<template>
  <consoHistory :title="$t('title.merchandising')" :type-filter="typeFilter" />
</template>

<script>
import { Merchandising } from "@/router/routeNames";

import consoHistory from "@/components/pages/consoHistory";
import dimensionEnum from "@/model/dimensionEnum";
import { snackProductTypeEnum } from "@/model/businessEnum";
export default {
  name: Merchandising,
  components: {
    consoHistory,
  },
  data() {
    return {
      typeFilter: {
        dimension: dimensionEnum.SNACKPRODUCT_TYPE,
        operator: "equals",
        values: [snackProductTypeEnum.Merchandising.toString()],
      },
    };
  },
};
</script>
